<div class="settings-layout">
  <h2>
    Configuration
  </h2>

  <!-- <h3 class="info-title">Debug console</h3>
  <div class="question-label checkbox debug-option" (click)="switchDebugConsole()"
       [ngClass]="{'selected': enableDebugConsole}">
    <i class="checkbox-placeholder"></i>
    <span>Enable debug console</span>
  </div> -->

  <h3 class="info-title">System information</h3>
  <div class="label info blue">
    Click on a setting to copy it.
  </div>
  <form>
    <label *ngFor="let info of systemInfo" class="form-group code-label"
           (click)="copyToClipboard(info[1])">
      <span class="code-title">{{info[0]}}:</span><br />
      <code>{{info[1]}}</code>
      <br /><br />
    </label>
    <input aria-label=""  id="snippet-code-id" type="text" value="" />
  </form>

  <div class="label info green copy-label" @flash *ngIf="isCopyLabelShown">
    Copied to clipboard!
  </div>
</div>
